module.exports = __webpack_public_path__ + "img/value_icon1.7662f523.png";